import { render, staticRenderFns } from "./ContributorAnswers.vue?vue&type=template&id=10911f84&scoped=true"
import script from "./ContributorAnswers.vue?vue&type=script&lang=js"
export * from "./ContributorAnswers.vue?vue&type=script&lang=js"
import style0 from "./ContributorAnswers.vue?vue&type=style&index=0&id=10911f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10911f84",
  null
  
)

export default component.exports